/**
 * Meta service — thin service-layer wrapper around backend metadata endpoints.
 * Components consume services, not raw HTTP, keeping data logic out of the UI.
 */
import { apiClient } from "@/lib/apiClient";

export const metaService = {
  async getHealth() {
    const { data } = await apiClient.get("/health");
    return data;
  },
  async getMeta() {
    const { data } = await apiClient.get("/meta");
    return data;
  },
  async getServicesStatus() {
    const { data } = await apiClient.get("/meta/services");
    return data;
  },
};
